import { CONFIG_KEY_PLAYER_PREF } from "@utils/deviceConfigKeys";
import { toAsciiSafeJson } from "./managementConfigFile";

export const API_KEY_CONFIG_FILENAME = "apikeyconfig.json";

export function apiKeyConfigJson(configKey: string): string {
  return toAsciiSafeJson({
    [CONFIG_KEY_PLAYER_PREF]: configKey === "unset" ? "" : configKey,
  });
}
